import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_264: DocMigration = {
  maxSchemaVersion: "0.0.264",
  description: "Migrates window-based wall framing parameters to window wall framing settings",
  apply(json: any) {
    if (json.settings) {
      let wallFramingSettings;
      for (const settingId of Object.keys(json.settings)) {
        const settings = json.settings[settingId];

        if (settings.type === "WALL_FRAMING_SETTINGS") {
          wallFramingSettings = settings;
        }
      }

      if (!wallFramingSettings) {
        return json;
      }

      if (wallFramingSettings.windowSettings) {
        json.settings[uid()] = {
          ...wallFramingSettings.windowSettings,
        };
        delete wallFramingSettings.windowSettings;
      }
      if (wallFramingSettings.doorSettings) {
        json.settings[uid()] = {
          ...wallFramingSettings.doorSettings,
        };
        delete wallFramingSettings.doorSettings;
      }
    }
    return json;
  },
};

export default migration_0_0_264;
